module.exports = __webpack_public_path__ + "static/media/bg_user2.395818c5.png";